/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Trend_SubtitleInputs */



/**
* | output |
* | --- |
* | "Daily AI usage cost across all organizations (last 30 days)." |
*
* @param {Partner_Dashboard_Trend_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_trend_subtitle = /** @type {((inputs?: Partner_Dashboard_Trend_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Trend_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tägliche KI-Nutzungskosten über alle Organisationen (letzte 30 Tage).")
	return /** @type {LocalizedString} */ ("Daily AI usage cost across all organizations (last 30 days).")
});